import React, { FC } from "react";
import { Droppable } from "react-beautiful-dnd";
import { ICategory } from "src/modules/categories/entity/categories/ICategory";
import { StyledDraggedContainer } from "./styles";
import { CategoryListItem } from "../categoryListItem";
import { INewsCategory } from "src/modules/newsCategories/entity/newsCategories/INewsCategory";

interface IProps {
    categories: INewsCategory[];
}

export const CategoryDroppableContainer: FC<IProps> = ({ categories }) => {

    return (
        <Droppable droppableId={`droppable_categories`} type={`PARENT_CATEGORY`}>
            {(provided, snapshot) => (
                <StyledDraggedContainer ref={provided.innerRef} isDraggingOver={snapshot.isDraggingOver} >
                    {categories.map((category, index) => (<CategoryListItem category={category} index={index} key={`CategoryDroppableContainer${category.id}${0}`} />))}
                    {provided.placeholder}
                </StyledDraggedContainer>
            )}
        </Droppable>
    );
};
